import React from "react";
import { Link } from "react-router-dom";
import { HiArrowNarrowLeft } from "react-icons/hi";
import logo from "@/assets/logo.png";

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-gray-600 hover:text-primary transition-colors">
            <HiArrowNarrowLeft className="w-5 h-5" />
            Retour
          </Link>
          <img src={logo} alt="Logo" className="h-8" />
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8 pb-16">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Conditions générales d'utilisation</h1>
        <p className="text-sm text-gray-400 mb-8">Dernière mise à jour : 15 août 2026</p>

        <div className="space-y-8 text-sm text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">1. Éditeur du service</h2>
            <p>
              Le présent service de pré-enregistrement en ligne (le « Service ») est édité par QUERCO, société à responsabilité limitée au capital de 500 €, dont le siège
              social est situé 2 rue du Neuberg, 68610 Lautenbach, France, immatriculée au RCS de Colmar sous le numéro 891 328 619 (« Querco » ou « l'Éditeur »).
            </p>
            <p className="mt-2">
              Directeur de la publication : Lucien Klein. Hébergeur : Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, États-Unis (téléphone :
              +1 650 319 8930). Contact :{" "}
              <a href="mailto:privacy@querco.co" className="text-primary hover:underline">
                privacy@querco.co
              </a>
              .
            </p>
            <p className="mt-2">
              Le Service est mis à disposition des patients pour le compte de laboratoires de biologie médicale partenaires (le « Laboratoire »), qui demeurent seuls
              responsables de la réalisation des examens de biologie médicale.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">2. Objet du Service</h2>
            <p>Le Service permet au patient de préparer son admission dans un Laboratoire avant sa venue, notamment :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>transmettre son ordonnance (photo ou fichier PDF) ;</li>
              <li>renseigner et vérifier ses informations administratives (identité, coordonnées, numéro de sécurité sociale) ;</li>
              <li>répondre au questionnaire préalable aux prélèvements ;</li>
              <li>consulter les consignes de préparation à ses examens ;</li>
              <li>signaler sa présence lors de son arrivée au Laboratoire ;</li>
              <li>réutiliser une ordonnance renouvelable déjà transmise.</li>
            </ul>
            <p className="mt-2">Le Service est gratuit. Son utilisation est facultative : le patient peut toujours se présenter directement à l'accueil du Laboratoire.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">3. Ce que le Service n'est pas</h2>
            <p>
              Le Service est un outil administratif de préparation de l'admission. Il ne fournit aucun avis, diagnostic ou conseil médical, ne constitue pas un dispositif
              médical et ne remplace pas l'échange avec le personnel du Laboratoire ou avec le médecin prescripteur.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Le pré-enregistrement ne vaut ni rendez-vous, ni promesse de prise en charge : le Laboratoire vérifie et valide chaque demande.</li>
              <li>L'ordonnance originale doit être présentée lors de la venue au Laboratoire.</li>
              <li>
                L'ordonnance transmise fait l'objet d'une analyse automatisée destinée à préparer le dossier ; son contenu est ensuite vérifié et validé par le personnel
                habilité du Laboratoire.
              </li>
              <li>En cas d'urgence médicale, contactez le 15 (SAMU) ou le 112.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">4. Conditions d'accès</h2>
            <p>
              Le Service est réservé aux personnes majeures. Il est possible d'effectuer un pré-enregistrement pour le compte d'un tiers majeur, à condition de disposer de
              son autorisation et de renseigner ses informations avec exactitude.
            </p>
            <p className="mt-2">
              L'accès à certaines fonctionnalités (préremplissage des informations, ordonnances renouvelables) nécessite une vérification d'identité par code à usage
              unique envoyé par e-mail ou SMS. Ce code est strictement personnel : ne le communiquez à personne.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">5. Obligations de l'utilisateur</h2>
            <p>En utilisant le Service, vous vous engagez à :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>fournir des informations exactes, complètes et à jour, et des documents lisibles dont vous êtes le titulaire légitime ;</li>
              <li>ne pas usurper l'identité d'un tiers ni utiliser les coordonnées d'un tiers sans son autorisation ;</li>
              <li>ne transmettre que des documents en lien avec votre admission (ordonnance, documents demandés par le questionnaire) ;</li>
              <li>ne pas perturber, détourner ou tenter de compromettre le fonctionnement ou la sécurité du Service.</li>
            </ul>
            <p className="mt-2">
              La communication d'informations inexactes peut entraîner l'impossibilité de traiter la demande et engager votre responsabilité. Le Laboratoire procède en
              tout état de cause aux vérifications d'identité requises lors de votre venue.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">6. Disponibilité du Service</h2>
            <p>
              L'Éditeur met en œuvre des moyens raisonnables pour assurer l'accès au Service, sans garantie de disponibilité ou de continuité. Le Service peut être
              suspendu à tout moment, notamment pour maintenance. En cas d'indisponibilité, présentez-vous directement à l'accueil du Laboratoire : votre prise en charge
              n'en est pas affectée.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">7. Responsabilité</h2>
            <p>
              Le Laboratoire est seul responsable de l'admission, de la réalisation des examens de biologie médicale et des décisions de prise en charge. L'Éditeur est
              responsable de la fourniture du Service dans les conditions prévues aux présentes ; il ne saurait être tenu responsable des dommages résultant d'une
              utilisation non conforme du Service, d'informations erronées fournies par l'utilisateur, ou d'une indisponibilité temporaire du Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">8. Propriété intellectuelle</h2>
            <p>
              Le Service, sa structure, ses textes, visuels et logiciels sont protégés par le droit de la propriété intellectuelle et demeurent la propriété exclusive de
              Querco ou de ses partenaires. Toute reproduction ou représentation, totale ou partielle, sans autorisation préalable est interdite. Les documents que vous
              transmettez restent les vôtres : vous concédez uniquement à Querco et au Laboratoire le droit de les traiter pour les besoins de votre admission.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">9. Données personnelles et cookies</h2>
            <p>
              Les traitements de données personnelles liés au Service sont décrits dans la{" "}
              <Link to="/privacy" className="text-primary hover:underline">
                politique de confidentialité
              </Link>{" "}
              et la{" "}
              <Link to="/cookies" className="text-primary hover:underline">
                politique cookies
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">10. Modification des CGU</h2>
            <p>
              L'Éditeur peut modifier les présentes conditions à tout moment. La version applicable est celle en vigueur au moment de l'utilisation du Service, accessible
              en permanence sur cette page. Toute modification substantielle sera portée à la connaissance des utilisateurs par tout moyen approprié avant son entrée en
              vigueur.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2">11. Droit applicable</h2>
            <p>
              Les présentes conditions sont soumises au droit français. En cas de litige et à défaut de résolution amiable, les tribunaux français seront compétents dans
              les conditions de droit commun.
            </p>
          </section>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-200 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link to="/privacy" className="text-primary hover:underline">
            Politique de confidentialité
          </Link>
          <Link to="/cookies" className="text-primary hover:underline">
            Politique cookies
          </Link>
        </div>
      </main>
    </div>
  );
};

export default Terms;
